import React from 'react';
import { Layout } from 'antd';
import { Row, Col } from 'antd';
import BannerIllustration from '../assets/ankUniLogo.png'; // İllüstrasyonu src/assets klasörüne ekleyin
import StatsSection from './StatsSection';

const { Header } = Layout;

const Banner = () => {

    return (
        <div className="ankara-banner">
            <Row style={{ width: '100%' }}>
                <Col xl={12} md={12} sm={24} >
                    <h1>ARDEK İLAN HAVUZU</h1>
                    <p>Araştırma Dekanlığı İlan Havuzu</p>
                </Col>
                <Col xl={12} md={12} sm={24} style={{ alignSelf: 'center' }}>
                    <StatsSection />
                </Col>
            </Row >
        </div >
    );
};

export default Banner;